import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { School } from 'src/app/model/school.model';
import { Student } from 'src/app/model/student/student.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { PfsReportResult } from './model/pfs-report-result.model';
import { PfsReportService } from './service/pfs-report.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UtilityService } from 'src/app/service/utility.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';

@Component({
    selector: 'pfs-report',
    templateUrl: './pfs-report.component.html',
    styleUrls: ['./pfs-report.component.scss']
})
export class PfsReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    allRegions: Region[] = [];
    allDistricts: SchoolDistrict[] = [];
    lstSelectedRegion: Region[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];
    lstSelectedschools: School[] = [];
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    isExporting: boolean = false;
    isExportingIndividual: any = [];
    hasExports: boolean = false;

    // Component variables
    resetField: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;
    progressSubscription: Subscription;
    progressInterval: number = 500;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstAcademicRiskResponse: PfsReportResult[];
    strExportFileName = 'PFS_Report';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Table display
    baseDisplayedColumns: string[] = ['MSD_NUMBER', 'SSID', 'PERSON.LAST_NAME', 'GRADES', 'QAD', 'MOBILITY'];
    caasppColumns: string[] = ['CAASPP_ELA_SCORE', 'CAASPP_MATH_SCORE'];
    celdtColumns: string[] = ['CELDT_SCORE'];
    elpacColumns: string[] = ['ELPAC_SCORE'];
    suffixColumns: string[] = ['EL_INDICATOR', 'ACADEMIC_RISK', 'DROPOUT'];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSources: MatTableDataSource<Student>[] = [];

    // Results
    results: PfsReportResult[] = [];
    displayName: string = '';
    filter: string = '';

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoadingResults: boolean = false;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private pfsService: PfsReportService,
        private apiMsinExportsService: ApiExportsService,
        private utilityService: UtilityService
    ) {}

    ngOnInit(): void {}

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.pfsService
                .search(
                    this.toNumberArray(this.chosenRegions),
                    this.toNumberArray(this.chosenCounties),
                    this.toNumberArray(this.chosenSchoolDistricts),
                    this.toNumberArray(this.chosenSchools),
                    this.selectedPerformancePeriod
                )
                .subscribe({
                    next: (res) => {
                        if (res.regions) {
                            this.results = res.regions.sort((n1: PfsReportResult, n2: PfsReportResult) => (n1.CODE! > n2.CODE! ? 1 : -1));

                            let prefixColumns = ['SCHOOL.COUNTy.COUNTY_NAME', 'SCHOOL.SCHOOL_DISTRICT.DISTRICTS', 'SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'Regions' : 'Region';
                        } else if (res.counties) {
                            this.results = res.counties.sort((n1: PfsReportResult, n2: PfsReportResult) => (n1.COUNTY_NAME! > n2.COUNTY_NAME! ? 1 : -1));

                            let prefixColumns = ['SCHOOL.SCHOOL_DISTRICT.DISTRICTS', 'SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                        } else if (res.schoolDistricts) {
                            this.results = res.schoolDistricts.sort((n1: PfsReportResult, n2: PfsReportResult) => (n1.DISTRICTS! > n2.DISTRICTS! ? 1 : -1));

                            let prefixColumns = ['SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                        } else if (res.schools) {
                            this.results = res.schools.sort((n1: PfsReportResult, n2: PfsReportResult) => (n1.SCHOOL_NAME! > n2.SCHOOL_NAME! ? 1 : -1));

                            let prefixColumns = ['SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'Schools' : 'School';
                        } else if (res.msg) {
                            this.results = [];
                            this.msg = res.msg;
                        } else {
                            this.results = [];
                            this.msg = { SUCCESS: false, MSG: 'Error retrieving PFS Report.' };
                        }
                    },
                    error: (err) => {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving PFS Report.' };
                    },
                    complete: () => {
                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();

                        // Display current performance period
                        this.currentPerformancePeriod = this.selectedPerformancePeriod;

                        // Expand all
                        this.expandAll(this.results);

                        // Display results
                        this.isLoading = false;
                    }
                });
        }
    }

    generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];

        displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        displayedColumns = displayedColumns.concat(this.caasppColumns);

        if (parseInt(schoolYear.substring(0, 4)) >= 2016 && parseInt(schoolYear.substring(0, 4)) <= 2017) {
            displayedColumns = displayedColumns.concat(this.celdtColumns);
        }

        if (parseInt(schoolYear.substring(0, 4)) >= 2017) {
            displayedColumns = displayedColumns.concat(this.elpacColumns);
        }

        if (parseInt(schoolYear.substring(0, 4)) >= 2016) {
            displayedColumns = displayedColumns.concat(this.suffixColumns);
        }

        return displayedColumns;
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
        payload.performancePeriod = this.selectedPerformancePeriod;

        return payload;
    }

    updateDataSource() {
        this.tableDataSources = [];

        setTimeout(() => {
            this.results.forEach((result, index) => {
                // Data
                let dataSource = new MatTableDataSource<Student>();
                dataSource.data = result.STUDENTS!;

                // Paginator
                dataSource.paginator = this.paginators.toArray()[index];

                // Sort
                dataSource.sort = this.sorts.toArray()[index];
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
                dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                // Filter
                dataSource.filterPredicate = (data: any, filter) => {
                    const dataStr = JSON.stringify(data).toLowerCase();
                    return dataStr.indexOf(filter) != -1;
                };

                this.tableDataSources.push(dataSource);
            });
        });
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.selectedPerformancePeriod) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];
        this.msg = {};
    }

    hasChild = (_: number, node: PfsReportResult) => !!node.STUDENTS && node.STUDENTS.length > 0;

    expandAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = true;
        });
    }

    collapseAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = false;
        });
    }

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    announceSortChange(sortState: Sort) {}

    isQadExpired(d: string) {
        if (moment(d).isValid()) {
            let qad = new Date(moment(d).format('LL'));
            let expiredDay = new Date(qad.getFullYear() + 3, qad.getMonth(), qad.getDate());
            const today = new Date(moment().format('LL'));

            if (expiredDay < today) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    downloadExcel(name?: string, data?: any[], index?: number) {
        let payload = this.generateExportPayload(data);

        if (payload.data.length > 0) {
            this.isExporting = true;
            if (index != null) {
                this.isExportingIndividual[index] = true;
            }
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportPfsReportExcel(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'application/xlsx' });

                    let fileName = this.utilityService.fnMakeFileNameTime(
                        ('PFS_Report_' + (name ? name + '_' : '') + this.selectedPerformancePeriod).replace(/\s+/g, '_')
                    );

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.xlsx';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting PFS Report.' };
                    this.isExporting = false;
                    if (index != null) {
                        this.isExportingIndividual[index] = false;
                    }
                },
                complete: () => {
                    this.isExporting = false;
                    if (index != null) {
                        this.isExportingIndividual[index] = false;
                    }
                }
            });
        }
    }

    generateExportPayload(data?: any[]) {
        let payload = {
            settings: {
                schoolYear: this.selectedPerformancePeriod
            },
            data: data ? data : this.results.flatMap((res) => res.STUDENTS)
        };

        return payload;
    }
}
